export default {
  opponentRank: {
    title: "Classement adverse",
    tabs: {
      byRanking: "Par classement",
      allRankings: "Tous les classements",
    },
    empty: {
      title: "Aucun classement adverse disponible",
    },
  },
};
